const vehicles = {
  vehicles: 'Veículos',

  headerButtons: {
    create: {
      createBtn: 'Criar',
    },

    import: 'Importar',
  },

  import: {
    title: 'Carregar Veículos',
  },

  toast: {
    error: {
      badResponse: '[Vehicle] resposta inválida do servidor',
      edit: {},
      create: {},
    },
    success: {
      edit: {
        resetSuccess: 'Com sucesso.',
      },
      create: {},
      delete: {
        default: '[Vehicle] excluído com sucesso',
      },
    },
  },
  table: {
    headers: {
      name: 'Nome',
      make: 'Fazer',
      model: 'Modelo',
      year: 'Ano',
      color: 'Cor',
      pax: 'Máximo de passageiros',
      minSeats: 'Mínimo de passageiros',
      supplier: 'Fornecedores',
      attributes: 'attributes',
      service: 'service'
    },
    filters: {
      supplier: 'Fornecedores',
    },
    actions: {
      delete: 'Remover',
      export: 'Exportar',
    },
    toolTip: {
      noPermission: 'Action not allowed: Permission required',
    },
  },
  deleteModal: {
    header: 'Excluir veículos',
    body: 'Você está prestes a excluir {{num}} veículos.',
  },

  create: {
    successToast: {
      message: 'sucesso! Veículo Criado!',
    },
    errorToast: {
      message: 'Ocorreu um erro. Não foi possível criar o veículo',
    },
  },

  edit: {
    successToast: {
      message: 'sucesso! Veículo Atualizado!',
    },
    errorToast: {
      message: 'Ocorreu um erro. Não foi possível atualizar o veículo',
    },

    suspendButton: {
      actionActivate: 'Reativar',
      actionDeactivate: 'Suspender',
    },
    suspendModal: {
      popupTitleActive: 'Veículo suspenso',
      popupTitleDeactivation: 'Reativar Veículo',
      popupTitleUnsuspend: 'Motivo de Anular a Suspensão',
      popupSubTitleDeactivation: 'Selecione o motivo da suspensão',
      popupActionActive: 'Reativar Veículo',
      popupActionDeactivate: 'Veículo suspenso',
    },
    activeStatusButton: {
      statusActive: 'Ativo',
      statusDeactivate: 'Inativa',
    },
    formTabs: {
      informationTab: 'Informação',
      notesTab: 'Observações',
      historyTab: 'Histórico',
      reservationPreferencesTab: 'Preferências de Reserva',
    },
  },

  form: {
    header: {
      createVehicle: {
        title: 'Criar',
      },

      updateVehicle: {
        title: 'Atualizar',
      },
    },
    footer: {
      confirmButtonText: {
        create: 'Enviar',
        update: 'Enviar',
      },
    },
    information: {
      details: {
        header: 'Informações Gerais',
        fields: {
          name: 'Nome',
          site: 'Local',
          year: 'Ano',
          location: 'Localização de início',
          make: 'Fazer',
          model: 'Modelo',
          color: 'Cor',
          suppliers: 'Fornecedores',
          code: 'Identificador Externo',
          vin: 'VIN',
          productID: 'Identificador do produto',
          licensePlate: 'Placa de Veículo',
          electric: 'Eléctrico',
          connectorType: 'Tipo de Conector',
        },
      },
      attributes: {
        header: 'Atributos',
      },
      suppliers: {
        header: 'Fornecedores',
        fields: {
          suppliers: 'Fornecedores',
        },
      },
      mileageInspection: {
        header: 'Quilometragem e inspeção',
        fields: {
          mileage: 'Quilometragem',
          mileageLastInspection: 'Milhagem na última inspeção',
          lastInspectionDate: 'Data da última inspeção',
          nextInspectionDate: 'Próxima data da inspeção',
        },
      },
      capacity: {
        header: 'Capacidade:',
        headerConfigurations: 'Configurações de Capacidade',
        fields: {
          seats: 'Máximo de lugares',
          minSeats: 'Mínimo de Assentos',
          attribute: 'Atributo',
          count: 'Contagem',
        },
        btnAddConfig: {
          title: 'Adicionar configuração',
        },
      },
      deliveriesDetails: {
        header: 'Detalhes de Entregas',
        fields: {
          maxWeight: 'Peso Máximo',
          maxVolume: 'Volume máximo',
        },
      },
      services: {
        header: 'Serviços',
      },
      insurance: {
        header: 'Seguro',
        fields: {
          typeOfInsurance1: 'Tipo de seguro 1',
          typeOfInsurance1_start: 'Data de início',
          typeOfInsurance1_end: 'Data de término',
          typeOfInsurance2: 'Tipo de seguro 2',
          typeOfInsurance2_start: 'Data de início',
          typeOfInsurance2_end: 'Data de término',
        },
      },
      dimensions: {
        header: 'Dimensões do Veículo',
      },
      getProductBtn: 'EXIBIR IDs de produtos GETT',
      excludedProfiles: {
        header: 'Perfis Excluídos',
        dualList: {
          profilesList: {
            header: 'Lista de Perfis',
          },
          excludedList: {
            header: 'Perfis Excluídos',
          },
        },
      },
    },
    valdations: {
      name: 'Campo de nomeação obrigatória',
      plateNumber: {
        matches: 'Máximo de passageiros deve ser um número',
        required: 'Máximo de passageiros é requerido',
      },
      service: 'Serviço com é necessário',
      pax: {
        matches: 'Pax deve ser um número',
        required: 'Pax é Necessário',
      },
      minSeats: {
        matches: 'O mínimo de Assentos deve ser um número',
        required: 'O mínimo de Assentos é Necessário',
      },
      model: 'Modelar com é obrigatório',
      color: 'Corar com é obrigatório',
      year: {
        matches: 'O ano deve ser um número',
        required: 'O Ano é Requerido',
      },
      licenseExpDate: 'A expiração da licença é obrigatória',
    },
  },

  statuses: {
    online: 'Online',
    suspended: 'Suspensa',
    onATrip: 'Em uma Viagem',
  },

  totalVehicles: 'Total de Veículos',
};

export default vehicles;
